import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from 'src/app/services/header.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;
  isISDMOrg = false;
  private orgLogoSub?: Subscription;

  constructor(private headerService: HeaderService) { }

  ngOnInit() {    
    this.orgLogoSub = this.headerService.orgLogo.subscribe((logoData: any) => {
      const organizationSubDomain = logoData && logoData.organizationSubDomain ? logoData.organizationSubDomain.toLowerCase() : '';
      this.isISDMOrg = organizationSubDomain === 'isdm';
    });
  }

  ngOnDestroy() {
    if (this.orgLogoSub) {
      this.orgLogoSub.unsubscribe();
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if ((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
      this.showScroll = true;
    } 
    else if (this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.hideScrollHeight) { 
      this.showScroll = false; 
    }
  }

  scrollToTop() { 
    var currentScroll = document.documentElement.scrollTop || document.body.scrollTop; 
    if (currentScroll > 0) {
      window.scrollTo(0,0);
    }
  }
  
  public dateYear = new Date();

  get loginFLagValue(): boolean {
    return !!localStorage.getItem('currentUser');
  }
}
